import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import { Box, Container, Grid } from "@material-ui/core";
import Footer from "../../components/Footer/Footer";
import * as RouteLists from "../Router/index";
import { connect } from "react-redux";
import { connectUserStore } from "../connectStore/connectUserStore";
import ThemeLink from "../ThemeLink/ThemeLink";
import {
  getCookie,
  setTokenCookie,
} from "../../utility/Cookie/CookiesFunction";
import back from "../../assets/imgs/background/back.jpg";
import { initGA, logPageView } from "../../utility/Google/Analytic";

const Layout = (props) => {
  let RouteOption = RouteLists.getRouterWithPath(props.routerKey);
  let HeaderShow;
  let FooterShow;
  let sizeContainer = RouteOption.sizeContainer
    ? RouteOption.sizeContainer
    : 10;
  const [height, setHeight] = useState(0);
  const [firstLoad, setFristLoad] = useState(false);

  if (!firstLoad) {
    setFristLoad(true);
    // props.getMeSet(false);
  }

  if (RouteOption) {
    if (RouteOption.isUsedHeader) HeaderShow = <Header />;

    if (RouteOption.isUsedFooter)
      FooterShow = (
        <footer>
          <Footer />
        </footer>
      );

    // if (RouteOption.isUsedSide || RouteOption.fullWidth)
    sizeContainer = 12;
  } else {
    HeaderShow = <Header />;
    FooterShow = (
      <footer>
        <Footer />
      </footer>
    );
  }

  useEffect(() => {
    let tokenCookie = getCookie("token");
    let tokenRedux = props.tokenData;

    setHeight(window.innerHeight);

    if (tokenCookie === null && tokenRedux !== null) {
      setTokenCookie(tokenRedux);
      document.location.reload();
    }

    if (!window.GA_INITIALIZED) {
      initGA();
      window.GA_INITIALIZED = true;
    }

    // Router.events.on('routeChangeError', onDone);
    // Router.events.on('routeChangeComplete', onDone);
    return () => {
      // Router.events.off('routeChangeComplete', onDone)
    };
  });

  const onDone = () => {
    logPageView();
    props.updateNotifCount();
  };

  return (
    <ThemeLink>
      <Box
        style={{
          backgroundImage: "url(" + back + ")",
          backgroundPosition: "top center",
          minHeight: height + "px",
        }}
      >
        {HeaderShow}
        <Box mt={RouteOption.maxWidth != undefined ? 0 : 2}>
          <Container
            style={RouteOption.containerStyle ? RouteOption.containerStyle : {}}
            maxWidth={
              RouteOption.maxWidth != undefined ? RouteOption.maxWidth : "lg"
            }
          >
            <Grid container>
              <Grid item xs={12} md={sizeContainer} sm={12}>
                <Box className={RouteOption.maxWidth != undefined ? "" : ""}>
                  {props.children}
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
        {FooterShow}
      </Box>
    </ThemeLink>
  );
};

const mapStateToProps = (state) => {
  return {
    routerKey: state.router.routerKey,
  };
};

export default connectUserStore(connect(mapStateToProps)(Layout));
